// extracted by css-extract-rspack-plugin
export default {"overlay":"src-components-common-LoadingOverlay-module__overlay-_obvuP"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"overlay\":\"src-components-common-LoadingOverlay-module__overlay-_obvuP\"}";
        // 1773737313999
        var cssReload = require("../../../../../node_modules/.pnpm/@rspack+core@1.7.6_@swc+helpers@0.5.19/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  